export default __webpack_public_path__ + "static/media/keyoff.0c374b75.svg";